import * as yup from "yup";

const BoardMemberValidationsForm =yup.object().shape( {
    first_name: yup.string().required("Firstname is Required"),
    middle_initial: yup.string().required("Middle Initial is Required"),
    last_name: yup.string().required("Last Name is Required"),
    // genre: yup.string().required("Genre is Required"),
    // cover_file: yup.mixed().required("Cover Image is required"),
    // avatar_file: yup.mixed().required("Avator Image is required"),
    // category: yup.number().required('Rating is required'),
    // release_date: yup.date().required("Release Date is required"),
    // applicant: yup.string().required("Applicant is required"),
    // permit_number: yup.string().required("Permit Number is required"),
    // premier_date:yup.date().required("Premier Date is required"),


});

export default BoardMemberValidationsForm;
